export default {
  warning: {
    summary: 'Nicht unterstützte Werkstoffzusammensetzung',
    details: 'Die Berechnung von ZTU-Diagrammen ist derzeit auf Werkstoffe beschränkt, bei denen der Gewichtsprozentsatz aller Elemente kleiner als {threshold} ist.',
  },
};
